import { useBreakpointValue } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import React, { useRef } from 'react'
import { useNavigate } from 'react-router'
import FullScreenModal from '~/components/specialized/FullScreenModal/FullScreenModal'
import { TCallAnalyticsTab } from '~/pages/Calls/CallDetails/CallDetailsAnalyticsContent'
import { CallDetailsContent } from '~/pages/Calls/CallDetails/CallDetailsContent'
import { CallDetailsPanel } from '~/pages/Calls/CallDetails/CallDetailsPanel'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import { CallInstance } from '@mangovoice/types'

interface CallDetailsViewProps {
  callId?: number
  callInstance?: CallInstance
  callInstanceLoading: boolean
  onClosed?: () => void
  onOpenModal?: () => void
  initialTab?: TCallAnalyticsTab
}

export const CallDetailsView = ({
  callId,
  callInstance,
  callInstanceLoading,
  onClosed,
  initialTab,
}: CallDetailsViewProps) => {
  const navigate = useNavigate()
  const [forceModalOpen, setForceModalOpen] = React.useState(false)
  const screenSizeRef = useRef('md')
  const screenSize =
    useBreakpointValue(
      {
        base: 'xs',
        sm: 'sm',
        md: 'md',
        lg: 'lg',
        xl: 'xl',
        '2xl': 'xxl',
      },
      { ssr: false },
    ) ?? screenSizeRef.current
  screenSizeRef.current = screenSize

  const handleOpenModal = () => {
    setForceModalOpen(true)
  }

  const handleClosed = () => {
    setForceModalOpen(false)
    onClosed?.()
  }
  const handleVoicemailClick = () => {
    if (!callInstance) return
    navigate(`${ApplicationRoutes.VOICEMAIL}/${callInstance.voicemail_id}`)
  }

  const isModal = screenSize === 'xs' || screenSize === 'sm' || forceModalOpen

  return (
    <>
      {!isModal && (
        <CallDetailsPanel
          callId={callId}
          callInstance={callInstance}
          callInstanceLoading={callInstanceLoading}
          onClosed={handleClosed}
          onOpenModal={handleOpenModal}
          initialTab={initialTab}
          onVoicemailClick={handleVoicemailClick}
        />
      )}

      {callInstance && (
        <FullScreenModal isOpen={isModal} onClose={handleClosed}>
          <Box
            flex="1"
            display="flex"
            flexDirection="column"
            minHeight={0}
            overflowY="auto"
            overscrollBehaviorY="contain"
          >
            <CallDetailsContent
              isModal={isModal}
              callId={callId}
              callInstance={callInstance}
              callInstanceLoading={callInstanceLoading}
              onClosed={handleClosed}
              onOpenModal={handleOpenModal}
              initialTab={initialTab}
            />
          </Box>
        </FullScreenModal>
      )}
    </>
  )
}
